import { useDebounceCallback } from "usehooks-ts";
import useGet from "../../useGet";
import { useState } from "react";

const useGetUsers = () => {
  const { data, paramsObject, setParamsObject } = useGet({
    url: "auth/admin_list",
    initialParams: {
      pageNo: 0,
      limit: 10,
      searchQuery: "",
    },
  });

  const [searchQuery, setSearchQuery] = useState("");

  const userList = data?.data?.data || [];
  const isUserListLoading = data?.isLoading || false;
  const status = data?.status || "";
  const error = data?.error || null;

  const debouncedSearch = useDebounceCallback((value) => {
    setParamsObject((prev) => ({
      ...prev,
      pageNo: 0,
      searchQuery: value,
    }));
  }, 700);

  const handleSearch = (value) => {
    debouncedSearch(value);
  };

  return {
    userList,
    isUserListLoading,
    status,
    error,
    handleSearch,
    searchQuery,
  };
};

export default useGetUsers;
